'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import { CollapsibleSection } from '../../collapsible-section';
import { Text } from '../../text';

import styles from './TimelineDetails.module.scss';

export type ContainerProps = BaseComponentProps & {
  title: string;
  description?: string;
  payload?: ReactNode;
  payloadDefaultOpen?: boolean;
  date: string;
  order?: number;
  onOpenSlot?: () => void;
  onCloseSlot?: () => void;
};

function TimelineDetails({
  style,
  className,
  title,
  description,
  payload,
  payloadDefaultOpen = false,
  date,
  testId = 'ui-timeline-details',
  onOpenSlot,
  onCloseSlot,
}: ContainerProps) {
  return (
    <span
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      {payload ? (
        <CollapsibleSection
          className={styles['section']}
          testId={`${testId}_collapsible-section`}
          title={title}
          description={description}
          defaultOpen={payloadDefaultOpen}
          onOpen={onOpenSlot}
          onClose={onCloseSlot}
        >
          <div className={styles['payload']}>{payload}</div>
        </CollapsibleSection>
      ) : (
        <>
          <span className={styles['title']} data-testid={`${testId}_title`}>
            {title}
          </span>
          {description && (
            <Text variety="annotation" className={styles['description']}>
              {description}
            </Text>
          )}
        </>
      )}
      <Text
        className={styles['date']}
        variety="annotation"
        data-testid={`${testId}_date`}
      >
        {date}
      </Text>
    </span>
  );
}

export { TimelineDetails };
